<template>
  <div class="pa-4">
    <AlertComponent :alertProps="alert" />
    <!-- Dialog pour l'édition/ajout -->
    <EditCreationDialog
      v-if="!!editedItem"
      :listNafItemActuelProps="listNafItemActuel"
      :dialogProps="dialog"
      :editedIndexProps="editedIndex"
      :editedItemProps="editedItem"
      @closeDialog="dialog = $event"
      @modificationData="updateModificationData()"
      @creationData="updateCreationData()"
    />
    <!-- Dialog pour la suppression -->
    <DeleteDialog
      :dialogDeleteProps="dialogDelete"
      :editedItemProps="editedItem"
      :editedIndexProps="editedIndex"
      @deleteItem="deleteItemDialog()"
      @closeDialog="dialogDelete = $event"
    />
    <!-- Tableau principal -->
    <v-card elevation="0" class="rounded-lg border">
      <v-card-title class="py-3 px-6 d-flex align-center">
        <div>
          <h6 class="text-h6 font-weight-bold mb-0">Liste des fournisseurs</h6>
          <span class="text-body-2 grey--text">Gérez vos partenaires commerciaux</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn :color="$colors[0]" dark rounded @click="addFournisseur()" class="ml-2">
          <v-icon left>mdi-plus</v-icon>
          Ajouter un fournisseur
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pa-0">
        <FournisseurDataTable
          @listDataAssureur="listDataAssureur = $event"
          :listDataAssureurModif="listDataAssureurModif"
          @editItem="editItem($event)"
          @deleteItem="deleteItem($event)"
          @listDataAssureurModif="listDataAssureurModif = $event"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import EditCreationDialog from "./dashboard-fournisseur/components/EditCreationDialog.vue";
import AlertComponent from "./dashboard-fournisseur/components/AlertComponent.vue";
import DeleteDialog from "./dashboard-fournisseur/components/DeleteDialog.vue";
import FournisseurDataTable from "./dashboard-fournisseur/components/FournisseurDataTable.vue";
export default {
  components: {
    EditCreationDialog: EditCreationDialog,
    DeleteDialog: DeleteDialog,
    AlertComponent: AlertComponent,
    FournisseurDataTable: FournisseurDataTable,
  },
  data() {
    return {
      listDataAssureurModif: false,
      alert: {
        show: false,
        type: "success",
        color: "",
        title: "",
        message: "",
        timeout: 5000,
      },
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      listNafItemActuel: [],
      editedItem: {},
      listDataAssureur: [],
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    addFournisseur() {
      this.dialog = true;
      this.editedIndex = -1;
    },
    updateModificationData() {
      this.listDataAssureurModif = true;
        this.showAlert(
          "success",
          "Modification réussie",
          `Le fournisseur "${this.editedItem?.fournisseur}" a été modifié avec succès.`
        );   
    },
    updateCreationData() {
      this.listDataAssureurModif = true;
        this.showAlert(
          "success",
          "Création réussie",
          `Le fournisseur "${this.editedItem?.fournisseur}" a été ajouté avec succès.`
        );
    },
    deleteItemDialog() {
      this.listDataAssureurModif = true;
      if (this.editedItem?.fournisseur.length > 0) {
        this.showAlert(
          "success",
          "Suppression réussie",
          `Le fournisseur "${this.editedItem?.fournisseur}" a été supprimé avec succès.`
        );
      }
    },
    showAlert(type, title, message, timeout = 5000) {
      this.alert = {
        show: true,
        type: type,
        color:
          type === "success"
            ? "green"
            : type === "error"
            ? "red"
            : type === "warning"
            ? "orange"
            : "blue",
        title: title,
        message: message,
        timeout: timeout,
      };

      // Auto-fermeture après le délai spécifié
      if (timeout > 0) {
        setTimeout(() => {
          this.alert.show = false;
        }, timeout);
      }
    },
    spliteList(list) {
      return list.split(",");
    },
    editItem(item) {
      this.editedIndex = this.listDataAssureur.findIndex((el) => el == item);
      //   this.listNafItemActuel = this.spliteList(item.codeNaf);
      this.editedItem = Object.assign({}, item);
      if (item.codeNaf !== "," || item.codeNaf.length > 0) {
        this.editedItem.codeNaf = this.spliteList(item.codeNaf);
        this.listNafItemActuel = [...this.editedItem.codeNaf];
      } else {
        this.editedItem.codeNaf = "";
        this.listNafItemActuel = "";
      }
      console.log(this.editedItem);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.listDataAssureur.findIndex((el) => el == item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>

<style scoped>
.p-4 {
  padding: 1rem;
}
.space-y-6 > * + * {
  margin-top: 1.5rem;
}
.bg-gray-100 {
  background-color: #f7fafc;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}
.font-medium {
  font-weight: 500;
}
.text-lg {
  font-size: 1.125rem;
}
.font-bold {
  font-weight: 700;
}
:deep(.v-data-table-header) {
  background-color: rgb(7, 164, 202) !important;
}
:deep(.theme--light.v-data-table
    > .v-data-table__wrapper
    > table
    > thead
    > tr:last-child
    > th) {
  color: white !important;
}
</style>
